<template>
  <div>
    {{relationLabel}}
  </div>
</template>
<script>
  export default {
    props: ['isRead'],
    data() {
      return {
        objectType: this.$cache.getDic("message_is_read"),
      }
    },
    computed:{
      relationLabel(){
        let label=''
        for(let i in this.objectType){
          if(this.isRead == this.objectType[i].code){
            label = this.objectType[i].name
          }
        }
        return label
      }
    }
  }

</script>

